import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class ResourceLoadingService {
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined)
  constructor() {}

  loading(isLoading: boolean) {
    this.isLoading.next(isLoading)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/resource-loading.service.ts